export default __webpack_public_path__ + "locales/fi/DowngradePlanDialog.json?hash=d8a16ae996b2894968388cba22c8d3f5";